const translations = {
    en: {
        AUTH_PAGE_HEADER_TITLE_SIGN_IN_AND_UP: "Registrarse / Iniciar sesión",
        AUTH_PAGE_HEADER_TITLE_SIGN_IN: "Iniciar sesión",
        AUTH_PAGE_HEADER_TITLE_SIGN_UP: "Registrarse",
        AUTH_PAGE_HEADER_TITLE_SIGN_IN_UP_TO_APP: " para continuar a ",
    
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_START: "¿Aún no estás registrado?",
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_SIGN_UP_LINK: "Regístrate",
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_END: "",
    
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_START: "¿Ya tienes una cuenta?",
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_SIGN_IN_LINK: "Iniciar sesión",
        AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_END: "",
    
        AUTH_PAGE_FOOTER_START: "Al continuar, aceptas nuestros ",
        AUTH_PAGE_FOOTER_TOS: "Términos de servicio",
        AUTH_PAGE_FOOTER_AND: " y ",
        AUTH_PAGE_FOOTER_PP: "Política de privacidad",
        AUTH_PAGE_FOOTER_END: "",
    
        DIVIDER_OR: "o",
    
        BRANDING_POWERED_BY_START: "Desarrollado por ",
        BRANDING_POWERED_BY_END: "",
        SOMETHING_WENT_WRONG_ERROR: "Algo salió mal. Por favor, inténtalo de nuevo.",
        SOMETHING_WENT_WRONG_ERROR_RELOAD: "Algo salió mal. Por favor, inténtalo más tarde o recarga la página.",

        THIRD_PARTY_PROVIDER_DEFAULT_BTN_START: "Continuar con ",
        THIRD_PARTY_PROVIDER_DEFAULT_BTN_END: "",

        THIRD_PARTY_ERROR_NO_EMAIL: "No se ha podido obtener el correo electrónico. Por favor, prueba a usar otro método.",
    
        EMAIL_PASSWORD_EMAIL_LABEL: "Correo electrónico",
        EMAIL_PASSWORD_EMAIL_PLACEHOLDER: "Dirección de correo electrónico",
    
        EMAIL_PASSWORD_PASSWORD_LABEL: "Contraseña",
        EMAIL_PASSWORD_PASSWORD_PLACEHOLDER: "Contraseña",
    
        EMAIL_PASSWORD_SIGN_IN_FORGOT_PW_LINK: "¿Olvidaste tu contraseña?",
        EMAIL_PASSWORD_SIGN_IN_SUBMIT_BTN: "INICIAR SESIÓN",
        EMAIL_PASSWORD_SIGN_IN_WRONG_CREDENTIALS_ERROR: "Combinación de correo electrónico y contraseña incorrecta",
    
        EMAIL_PASSWORD_SIGN_UP_SUBMIT_BTN: "REGISTRARSE",
    
        EMAIL_PASSWORD_EMAIL_ALREADY_EXISTS: "Este correo electrónico ya existe. Por favor, inicia sesión en su lugar",
    
        EMAIL_PASSWORD_RESET_HEADER_TITLE: "Restablece tu contraseña",
        EMAIL_PASSWORD_RESET_HEADER_SUBTITLE: "Te enviaremos un correo electrónico para restablecer tu contraseña",
        EMAIL_PASSWORD_RESET_SEND_FALLBACK_EMAIL: "tu cuenta",
        EMAIL_PASSWORD_RESET_SEND_BEFORE_EMAIL: "Se ha enviado un correo electrónico de restablecimiento de contraseña a ",
        EMAIL_PASSWORD_RESET_SEND_AFTER_EMAIL: ", si existe en nuestro sistema.",
        EMAIL_PASSWORD_RESET_RESEND_LINK: "Reenviar o cambiar correo electrónico",
        EMAIL_PASSWORD_RESET_SEND_BTN: "Envíame un correo",
        EMAIL_PASSWORD_RESET_SIGN_IN_LINK: "Iniciar sesión",
    
        EMAIL_PASSWORD_RESET_SUBMIT_PW_SUCCESS_HEADER_TITLE: "¡Éxito!",
        EMAIL_PASSWORD_RESET_SUBMIT_PW_SUCCESS_DESC: "Tu contraseña ha sido actualizada correctamente",
        EMAIL_PASSWORD_RESET_SUBMIT_PW_SUCCESS_SIGN_IN_BTN: "INICIAR SESIÓN",
    
        EMAIL_PASSWORD_NEW_PASSWORD_LABEL: "Nueva contraseña",
        EMAIL_PASSWORD_NEW_PASSWORD_PLACEHOLDER: "Nueva contraseña",
        EMAIL_PASSWORD_CONFIRM_PASSWORD_LABEL: "Confirmar contraseña",
        EMAIL_PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER: "Confirma tu contraseña",
    
        EMAIL_PASSWORD_RESET_SUBMIT_PW_HEADER_TITLE: "Cambia tu contraseña",
        EMAIL_PASSWORD_RESET_SUBMIT_PW_HEADER_SUBTITLE: "Ingresa una nueva contraseña abajo para cambiar tu contraseña",
        EMAIL_PASSWORD_RESET_SUBMIT_PW_CHANGE_PW_BTN: "CAMBIAR CONTRASEÑA",
        EMAIL_PASSWORD_RESET_PASSWORD_INVALID_TOKEN_ERROR: "Token de restablecimiento de contraseña inválido",
    
        ERROR_EMAIL_NON_STRING: "El correo electrónico debe ser de tipo cadena de texto",
        ERROR_EMAIL_INVALID: "El correo electrónico no es válido",
    
        ERROR_PASSWORD_NON_STRING: "La contraseña debe ser de tipo cadena de texto",
        ERROR_PASSWORD_TOO_SHORT: "La contraseña debe contener al menos 8 caracteres, incluyendo un número",
        ERROR_PASSWORD_TOO_LONG: "La contraseña no debe superar los 100 caracteres",
        ERROR_PASSWORD_NO_ALPHA: "La contraseña debe contener al menos una letra",
        ERROR_PASSWORD_NO_NUM: "La contraseña debe contener al menos un número",
        ERROR_CONFIRM_PASSWORD_NO_MATCH: "La contraseña de confirmación no coincide",
    
        ERROR_NON_OPTIONAL: "El campo no es opcional",

        EMAIL_VERIFICATION_RESEND_SUCCESS: "Correo reenviado",
        EMAIL_VERIFICATION_SEND_TITLE: "¡Verifica tu correo electrónico!",
        EMAIL_VERIFICATION_SEND_DESC_START: "",
        EMAIL_VERIFICATION_SEND_DESC_STRONG: "Por favor, haz clic en el enlace",
        EMAIL_VERIFICATION_SEND_DESC_END: " en el correo que te acabamos de enviar para confirmar tu dirección de correo electrónico.",
        EMAIL_VERIFICATION_RESEND_BTN: "Reenviar correo",
        EMAIL_VERIFICATION_LOGOUT: "Cerrar sesión",
        EMAIL_VERIFICATION_SUCCESS: "¡Verificación de correo electrónico exitosa!",
        EMAIL_VERIFICATION_CONTINUE_BTN: "CONTINUAR",
        EMAIL_VERIFICATION_CONTINUE_LINK: "Continuar",
        EMAIL_VERIFICATION_EXPIRED: "El enlace de verificación de correo ha expirado",
        EMAIL_VERIFICATION_ERROR_TITLE: "Algo salió mal",
        EMAIL_VERIFICATION_ERROR_DESC: "Hemos encontrado un error inesperado. Por favor, contacta con soporte para recibir ayuda",
        EMAIL_VERIFICATION_LINK_CLICKED_HEADER: "Verifica tu dirección de correo electrónico",
        EMAIL_VERIFICATION_LINK_CLICKED_DESC: "Por favor, haz clic en el botón de abajo para verificar tu dirección de correo electrónico",
        EMAIL_VERIFICATION_LINK_CLICKED_CONTINUE_BUTTON: "CONTINUAR",
    }
}

export default translations;
